import axios from "axios";
import { lodgingApi as defaultLodgingApi } from "@b2bportal/lodging-api";

export const hotelsApi = defaultLodgingApi(axios);
